import React, { useState, useEffect, useRef } from "react";
// import Swiper from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Lazy,
  Autoplay,
  EffectFade,
} from "swiper";

// import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "./videoSlider.css";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/scrollbar/scrollbar.scss";
import {
  createStyles,
  Grid,
  IconButton,
  makeStyles,
  Theme,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import BookIcon from "@material-ui/icons/Book";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_WEBTOONS } from "../../../quries/webtoon";
import { GET_CONCERT_MENU } from "../../../quries/concert_video";
import { GET_ALL_VIDEO } from "../../../quries/video";

import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

// install Swiper components
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectFade]);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    totalSector: {
      marginTop: "8%",
      display: "flex",
      fontFamliy: "Noto Sans KR",
    },
    leftDivSector: { paddingRight: "6rem" },
    imgSec: {
      // position: "relative",
      width: "100%",
    },

    aspectRatioBox: {
      //   height: 0,
      overflow: "hidden",
      //   paddingTop: "calc(591.44px / 1127.34px * 100%)",
      //   paddingTop: "100%",
      // paddingTop: "56.25%",
      paddingTop: "42%",

      //   position: "relative",
    },

    aspectRatioBoxInside: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
    },
    fireboxCentering: {
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },

    viewPortSizing: {
      fontSize: "5vw",
    },
  })
);

interface AspectDivVideoProps {
  children: React.ReactNode;
}

function AspectDivVideo(props: AspectDivVideoProps) {
  const classes = useStyles();

  return (
    <div
      className={classes.aspectRatioBox}
      style={{
        backgroundImage:
          "linear-gradient(45deg,var(--gradient-red-start),var(--gradient-red-end))",
      }}
    >
      <div className={classes.aspectRatioBoxInside}>
        <div className={classes.fireboxCentering}>
          <div className={classes.viewPortSizing}>{props.children}</div>
        </div>
      </div>
    </div>
  );
}

interface VideoSliderProps {
  setVideoTitle: any;
}

function VideoSlider() {
  const [swiperInstance, setSwiperInstance] = useState<any>(null);
  const [state, setState] = useState<any>([]);
  const [finalState, setFinalState] = useState<any>([]);
  const [concertVideo, setConcertVideo] = useState<any>([]);
  const [laborIssueVideo, setLaborIssueVideo] = useState<any>([]);
  const [citizenVideo, setCitizenVideo] = useState<any>([]);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  const prevRef = useRef<HTMLDivElement>(null);
  const nextRef = useRef<HTMLDivElement>(null);

  function date_desending(a: any, b: any) {
    let dateA = new Date(a["date"]).getTime();
    let dateB = new Date(b["date"]).getTime();
    return dateA < dateB ? 1 : -1;
  }

  const { data, loading, error } = useQuery(GET_ALL_VIDEO, {
    // pollInterval: 2000,
    fetchPolicy: "no-cache",

    variables: {
      limit: 5,
      sort: "created_date:DESC",
    },
  });

  useEffect(() => {
    if (data) {
      if (data.concertVideos && data.concertVideos.length > 0) {
 
        setConcertVideo(data.concertVideos);
      }
      if (data.citizenJoyVideos && data.citizenJoyVideos.length > 0) {
        setCitizenVideo(data.citizenJoyVideos);
      }
      if (data.laborIssueVideos && data.laborIssueVideos.length > 0) {
        setLaborIssueVideo(data.laborIssueVideos);
      }
    }

    return () => {
      setConcertVideo(null);
      setLaborIssueVideo(null);
      setCitizenVideo(null);
    };
  }, [data]);

  useEffect(() => {
    if (concertVideo && concertVideo.length > 0) {
      concertVideo.map((video: any) => {
        setState((prev: any) => {
          return [
            ...prev,
            {
              // id: video.id,
              title: video.title,
              date: video.created_date,
              url: video.url,
            },
          ];
        });
      });
    }

    return () => {
      setState([]);
    };
  }, [concertVideo]);

  useEffect(() => {
    if (citizenVideo && citizenVideo.length > 0) {
      citizenVideo.map((video: any) => {
   
        setState((prev: any) => {
          return [
            ...prev,
            {
              // id: video.id,
              title: video.title,
              date: video.created_date,
              url: video.video_url,
            },
          ];
        });
      });
    }
    return () => {
      setState([]);
    };
  }, [citizenVideo]);

  useEffect(() => {
    if (laborIssueVideo && laborIssueVideo.length > 0) {
      laborIssueVideo.map((video: any) => {
 
        setState((prev: any) => {
          return [
            ...prev,
            {
              // id: video.id,
              title: video.title,
              date: video.created_date,
              url: video.video_url,
            },
          ];
        });
      });
    }
    return () => {
      setState([]);
    };
  }, [laborIssueVideo]);

  useEffect(() => {
    let orderBy: [] = state.sort(date_desending);
   
    setFinalState(orderBy.slice(0, 4));
    return () => {
      setFinalState([]);
    };
  }, [state]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error) {
    console.log(error);
  }

  // useEffect(() => {
  //   const swiper = new Swiper(".swiper-container", {
  //     speed: 1000,
  //     // spaceBetween: 100,
  //     autoplay: {
  //       delay: 10000,
  //     },
  //     navigation: {
  //       nextEl: ".swiper-button-next",
  //       prevEl: ".swiper-button-prev",
  //     },
  //     pagination: {
  //       el: ".swiper-pagination",
  //       dynamicBullets: true,
  //       renderBullet: function (index, className) {
  //         return (
  //           '<span class="' +
  //           className +
  //           " video-banner" +
  //           '">' +
  //           (index + 1) +
  //           "</span>"
  //         );
  //       },
  //     },
  //   });
  //   setSwiperInstance(swiper);
  // }, []);

  return (
    <Swiper
      // id="webtoon-slider"
      style={{ height: "100%" }}
      tag="section"
      wrapperTag="div"
      navigation={{
        prevEl: prevRef.current!, // Assert non-null
        nextEl: nextRef.current!, // Assert non-null
      }}
      pagination
      // pagination={{ clickable: true }}
      // spaceBetween={0}
      // slidesPerView={1}
      onInit={(swiper) => {
        // setVideoTitle(state[swiper.activeIndex].title);
      }}
      onSlideChange={(swiper) => {
        // setVideoTitle(state[swiper.activeIndex].title);
      }}
      // onReachEnd={() => console.log("Swiper end Reached")}
      // onSwiper={(swiper) => console.log(swiper)}
    >
      {/* {slides} */}

      {finalState.map((element: any, index: any) => {
        return (
          <SwiperSlide key={`webtoon-slide-${index}`} tag="div">
            <ReactPlayer
              url={`${element.url}`}
              width="100%"
              height="100%"
              controls={true}
              light={true}
              // stopOnUnmount
              // pip={true}
            />
          </SwiperSlide>
        );
      })}
      <div
        ref={prevRef}
        style={{
          position: "absolute",
          top: !matches ? 224 : 68,
          left: !matches ? 24 : 0,
          zIndex: 1,
        }}
      >
        <IconButton>
          <ArrowBackIosIcon fontSize={"large"} style={{ color: "#bc243c" }} />
        </IconButton>
      </div>
      <div
        ref={nextRef}
        style={{
          position: "absolute",
          top: !matches ? 224 : 68,
          right: !matches ? 24 : 0,
          zIndex: 1,
        }}
      >
        <IconButton>
          <ArrowForwardIosIcon
            fontSize={"large"}
            style={{ color: "#bc243c" }}
          />
        </IconButton>
      </div>
    </Swiper>
    // <div className="swiper-container" style={{ width: "100%", height: "100%" }}>
    //   <div className="swiper-wrapper">
    //     <div className="swiper-slide">
    //       <Grid xs={12} item container style={{ height: "15%" }}>
    //         <Grid
    //           xs={8}
    //           item
    //           container
    //           //   justify={"center"}
    //           alignContent={"center"}
    //           alignItems={"center"}
    //           style={{
    //             fontSize: 24,
    //             fontFamily: "Noto Sans KR",
    //             fontWeight: 700,
    //             paddingLeft: 72,
    //           }}
    //         >
    //           직장 내 괴롭힘 금지법 토론회
    //         </Grid>
    //         <Grid
    //           xs={3}
    //           item
    //           container
    //           justify={"center"}
    //           alignContent={"center"}
    //           alignItems={"center"}
    //           style={{
    //             fontSize: 24,
    //             fontFamily: "Noto Sans KR",
    //             fontWeight: 700,
    //             textAlign: "right",
    //             color: "rgba(0, 0, 0, 0.6)",
    //           }}
    //         >
    //           2020-09-17
    //         </Grid>
    //       </Grid>
    //       {/* <AspectDivVideo>

    //       </AspectDivVideo> */}
    //       <ReactPlayer
    //         url="https://www.youtube.com/watch?v=7HQFn8SQSfU&t=2614s"
    //         width="100%"
    //         height="85%"
    //         controls={true}
    //       />
    //     </div>

    //   </div>
    //   {/* <div className="swiper-pagination">
    //     <span className="swiper-pagination-bullet"></span>
    //   </div> */}
    //   <div
    //     className="swiper-button-prev video-banner-prev"
    //     style={{ left: "2%", color: "black" }}
    //   ></div>
    //   <div
    //     className="swiper-button-next video-banner-next"
    //     style={{ right: "2%", color: "black" }}
    //   ></div>
    // </div>
  );
}

export default VideoSlider;
